const M = [
  {
    name: "myApps",
    zh: "我的应用",
    en: "My apps"
  },
  {
    name: "dragTips",
    zh: "按住拖动调整顺序（最多7个）",
    en: "Press and drag to reorder(uo to 7)"
  },
  {
    name: "utilities",
    zh: "生活缴费",
    en: "Utilities"
  },
  {
    name: "financialService",
    zh: "金融服务",
    en: "Financial service"
  },
  {
    name: "travelService",
    zh: "出行服务",
    en: "Travel service"
  },
  {
    name: "lifeService",
    zh: "生活服务",
    en: "Life service"
  },
  {
    name: "payWaterBills",
    zh: "缴纳水费",
    en: "Water bills payment"
  },
  {
    name: "payElectricityBills",
    zh: "缴纳电费",
    en: "Electricity bills payment"
  },
  {
    name: "payInternetBills",
    zh: "缴纳网费",
    en: "Internet bills payment"
  },
  {
    name: "grabRecharge",
    zh: "Grab充值",
    en: "Grab Load"
  },
  {
    name: "bank",
    zh: "银行",
    en: "Bank"
  },
  {
    name: "loan",
    zh: "贷款",
    en: "Loan"
  },
  {
    name: "eWallet",
    zh: "电子钱包",
    en: "E-wallet"
  },
  {
    name: "insurance",
    zh: "保险",
    en: "Insurance"
  },
  {
    name: "realEstate",
    zh: "房地产",
    en: "Real estate"
  },
  {
    name: "cebuAir",
    zh: "宿务航空",
    en: "Cebu air"
  },
  {
    name: "government",
    zh: "政府",
    en: "Government"
  },
  {
    name: "paymentGateway",
    zh: "支付网关",
    en: "Payment gateway"
  },
  {
    name: "fillPaymentInfo",
    zh: "填写缴费信息",
    en: "Fill in the payment information"
  },
  {
    name: "deadline",
    zh: "截止时间",
    en: "Deadline"
  },
  {
    name: "pleaseFillIn",
    zh: "请填写",
    en: "Fill in "
  },
  {
    name: "overdue",
    zh: "已逾期，需缴纳",
    en: "Overdue, payment required"
  },
  {
    name: "overdueFees",
    zh: "逾期费用",
    en: "Overdue fees"
  },
  {
    name: "billingExample",
    zh: "账单示例",
    en: "Billing example"
  },
  {
    name: "serviceAssistance",
    zh: "客服协助",
    en: "Service assistance"
  },
  {
    name: "billingExampleTips",
    zh: "请拍摄清晰的照片，方便我们帮您处理。人工审核时间为3个工作日。",
    en:
      "Take a clear picture so that we can help you deal with it. The manual review time is 3 working days"
  },
  {
    name: "eWalletTips",
    zh:
      "Gcash每个账户每月只有7000P免费充值额度，超过以后Gcash后会扣除充值金额的2%",
    en:
      "Each Gcash account has only 7000P free recharge per month, and 2% of the recharge amount will be deducted after the Gcash exceeds the limit."
  }
];

export default M;
